import React from 'react';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import Zoom from 'react-reveal/Zoom';
import {useHistory} from "react-router-dom";

export const PortfolioHeader = () => {
    const history = useHistory();
    const backToDashboard =() => {
        history.goBack();
    }
    return (
        <Zoom>
            <div className='portfolio-header'>
                <h2 onClick={() => backToDashboard()}>Prakash Tiwari</h2>
                <DensityMediumIcon className='mui-bar'/>
            </div>
        </Zoom>
    );
}